// extracted by mini-css-extract-plugin
export var numberInputContainer = "_69-0";
export var startPickingButton = "_69-1";